import cn from 'classnames';
import React from 'react';
import { IconSearchFilterSvg } from 'apps/sigma2-ui/src/filters-v2/components/IconSearchFilter';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { IconClearSearchFilterSvg } from 'apps/sigma2-ui/src/filters-v2/components/IconClearSearchFilter';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export interface FilterSearchBoxProps {
  /**
   * The current value of the search box
   */
  value: string;

  /**
   * Callback when the search box value changes
   * @param newValue
   */
  onChange: (newValue: string) => void;
}

export const FilterSearchBox = ({ value, onChange }: FilterSearchBoxProps) => {
  const language = useLanguage();

  return (
    <div className="inline-block w-full relative">
      <IconSearchFilterSvg
        svg={{
          className:
            'absolute top-1/2 left-3 transform -translate-y-1/2 w-5 h-5 text-gray-400',
        }}
      />

      <input
        type={'text'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={language.filterSearchBoxPlaceholder()}
        className={cn(
          'form-input w-full border-[1px] border-gray-200 rounded px-3 py-2 pl-11 focus:outline-none text-gray-900 placeholder:text-gray-600 text-xs font-sans font-normal leading-normal focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus:border-blue-500 focus-visible:border-blue-500 transition-colors',
          {
            'pr-11': value !== '',
          },
        )}
      />

      {value !== '' && (
        <TouchTarget
          content={({ hovered }) => (
            <IconClearSearchFilterSvg
              svg={{
                className: cn('w-5 h-5 text-gray-400', {
                  'text-gray-600': hovered,
                }),
              }}
            />
          )}
          behavior={{
            type: 'onClick',
            onClick: () => {
              onChange('');
            },
          }}
          className={
            'absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer'
          }
        />
      )}
    </div>
  );
};
